import * as React from 'react'
import * as ReactDOM from 'react-dom'

import App from '~/components/App'
import './index.css'

import registerServiceWorker from './registerServiceWorker'

ReactDOM.render(<App />, document.getElementById('root') as HTMLElement)
registerServiceWorker()

document.getElementById('initial-loading')!.classList.add('app-loaded')



// WEBPACK FOOTER //
// ./src/index.tsx